module.exports = __webpack_public_path__ + "img/footer4.54cd2ceb.png";